class FooterOffice {
  constructor(element) {
    this.footer = element;
    this.officeButtons = this.footer.querySelectorAll('.office__btn');
    this.activeButton = null;

    this.init();
  }

  init() {
    this.officeButtons.forEach((button) => {
      button.addEventListener('click', (e) => this.handleButtonClick(e, button));
    });
  }

  handleButtonClick(e, button) {
    e.preventDefault();
    e.stopPropagation();

    if (this.activeButton === button && button.classList.contains('active')) {
      this.closeOffice(button);
      return;
    }

    if (this.activeButton && this.activeButton !== button) {
      this.closeOffice(this.activeButton);
    }

    this.openOffice(button);
  }

  openOffice(button) {
    button.classList.add('active');
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('aria-label', button.dataset.labelHide || button.getAttribute('aria-label'));
    this.activeButton = button;
  }

  closeOffice(button) {
    if (!button) {
      return;
    }

    button.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', button.dataset.labelShow || button.getAttribute('aria-label'));
    if (this.activeButton === button) {
      this.activeButton = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const footerElement = document.querySelector('.footer');
  if (footerElement) {
    new FooterOffice(footerElement);
  }
});

export default FooterOffice;
